// extracted by mini-css-extract-plugin
export default {"wrapper":"AlreadyDiagnosed_wrapper__wRdSn"};